(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promo-code"] && !Shopify.designMode) return;
  try {
    (function () {
    function copier(texte) {
      // Copie synchrone d'abord (<textarea> + execCommand, dans le geste du clic), l'API
      // navigator.clipboard seulement en secours. Inversé le 2026-10-13 : dans un navigateur
      // intégré, writeText peut rester EN ATTENTE sans jamais répondre, et le bouton ne
      // passait jamais à « Copié ! » (constaté en test, même défaut sur le bandeau).
      var ok = false;
      var zone = document.createElement('textarea');
      zone.value = texte;
      zone.setAttribute('readonly', '');
      zone.style.cssText = 'position:fixed;top:-9999px;opacity:0';
      document.body.appendChild(zone);
      zone.select();
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(zone);
      if (ok) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texte);
      return Promise.reject();
    }

    // Recalcule la période active dans le navigateur (voir le commentaire en tête).
    function maintenant() {
      var m = /[?&]promo_date=([^&]+)/.exec(window.location.search);
      var t = m ? new Date(decodeURIComponent(m[1])).getTime() : NaN;
      return Math.floor((isNaN(t) ? Date.now() : t) / 1000);
    }

    function actualiser(racine) {
      var t = maintenant();
      (racine || document).querySelectorAll('.promo-code[data-calendrier]').forEach(function (bouton) {
        var d = bouton.dataset.defaut.split('|');
        var remise = d[0], label = d[1], code = d[2];
        bouton.dataset.calendrier.split(';').some(function (ligne) {
          var c = ligne.split('|');
          if (t >= +c[0] && t <= +c[1]) {
            remise = c[2]; label = 'sur votre commande'; code = c[5];
            return true;
          }
          return false;
        });
        if (!code) { bouton.hidden = true; return; }
        // N'écrire que ce qui change : l'observateur ci-dessous verrait sinon ses propres
        // écritures et tournerait en boucle.
        if (bouton.dataset.code === code && bouton.dataset.actualise) return;
        bouton.dataset.actualise = '1';
        var eyebrow = bouton.querySelector('[data-ref="eyebrow"]');
        var valeur = bouton.querySelector('[data-ref="valeur"]');
        if (eyebrow) eyebrow.textContent = remise + ' ' + label;
        if (valeur) valeur.textContent = code;
        bouton.dataset.code = code;
        bouton.setAttribute('aria-label', remise + ' ' + label + ' — ' + bouton.dataset.copier + ' ' + code);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { actualiser(); });
    } else {
      actualiser();
    }
    // La page produit re-rend ses blocs au changement de variante : on repasse dessus,
    // une fois par image au plus.
    var enAttente = false;
    new MutationObserver(function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; actualiser(); });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('click', function (evenement) {
      var bouton = evenement.target.closest('.promo-code');
      if (!bouton || bouton.classList.contains('is-copied')) return;

      copier(bouton.dataset.code).then(function () {
        var texte = bouton.querySelector('[data-ref="action-text"]');
        var annonce = bouton.querySelector('[data-ref="annonce"]');
        var avant = texte ? texte.textContent : '';

        bouton.classList.add('is-copied');
        if (texte) texte.textContent = bouton.dataset.copie;
        if (annonce) annonce.textContent = bouton.dataset.copie;

        setTimeout(function () {
          bouton.classList.remove('is-copied');
          if (texte) texte.textContent = avant;
          if (annonce) annonce.textContent = '';
        }, 2000);
      }).catch(function () {
        // Copie refusée : on ne casse rien, le code reste lisible et sélectionnable.
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
